// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2EH3x","title":"Header_title__2WEEg","left":"Header_left__2MT07","clinicName":"Header_clinicName__1hc_o"};